import { render } from "./EventExportsView.vue?vue&type=template&id=9061539e&scoped=true"
import script from "./EventExportsView.vue?vue&type=script&lang=js"
export * from "./EventExportsView.vue?vue&type=script&lang=js"

import "./EventExportsView.vue?vue&type=style&index=0&id=9061539e&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9061539e"]])

export default __exports__